import React          from 'react';
import { Collapse }   from 'react-bootstrap'
import classnames     from 'classnames';
import HasArray       from './HasArray';
import Panelized      from './Panelized';
import YesPanelized   from './SectionYesPanelized';
import NoPanelized    from './SectionNoPanelized';
import TabRoutScoring from './TabRoutScoring';

const SectionPanelized = (props) => (
  <div className="array-need">
    <HasArray {...props} />
    <Collapse in={props.parameters.has_array === '1'}>
      <div>
        <div className="array-fields">
          <Panelized {...props} />
          <Collapse in={props.parameters.is_panelized === '1'}>
            <div className="yes-panelized">
              <YesPanelized {...props} />
            </div>
          </Collapse>
          <Collapse in={props.parameters.is_panelized === '0'}>
            <div className="no-panelized">
              <NoPanelized {...props} />
            </div>
          </Collapse>
          <div
            className={classnames({ hidden: props.parameters.is_panelized === undefined || props.parameters.is_panelized === '' })}>
            <TabRoutScoring {...props} />
          </div>
        </div>
      </div>
    </Collapse>
  </div>
);

export default SectionPanelized;
